var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCancellation = function SvgCancellation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#FFF",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M7,0.506145606 C10.5898509,0.506145606 13.5,3.41629473 13.5,7.00614561 C13.5,10.5959965 10.5898509,13.5061456 7,13.5061456 C3.41014913,13.5061456 0.5,10.5959965 0.5,7.00614561 C0.5,3.41629473 3.41014913,0.506145606 7,0.506145606 Z M7,2.00614561 C4.23857625,2.00614561 2,4.24472186 2,7.00614561 C2,9.76756936 4.23857625,12.0061456 7,12.0061456 C9.76142375,12.0061456 12,9.76756936 12,7.00614561 C12,4.24472186 9.76142375,2.00614561 7,2.00614561 Z M9.95170499,6.25 L9.95170499,7.75 L4,7.75 L4,6.25 L9.95170499,6.25 Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancellation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancellation.91e3840d.svg";
export { ForwardRef as ReactComponent };